import {AiCampaignType, CampaignType} from 'common/src/modules/campaigns/campaigns.types';
import tabularDataToCsv from 'common/src/modules/shared/copilot/csvUtils/tabularDataToCsv';
import {objectStatusName} from 'common/src/modules/enums/static/ObjectStatus';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import getMatchingEnumValue from 'common/src/utils/typescriptUtils/getMatchingEnumValue';
import {z} from 'zod';
import {CampaignsAgentsToolsNames} from '../copilotCampaigns.enums';

const inputSchema = z.object({
  campaignsToSearchFor: z
    .array(
      z.object({
        id: z.number().optional().describe('The campaign ID'),
        name: z.string().optional().describe('The campaign name'),
      }),
    )
    .max(10, 'the max number of campaigns to get the metadata for is 10'),
});

export default function getCampaignsMetadataTool(store: CLStore) {
  async function execute({
    input: {campaignsToSearchFor},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    let campaigns = store.getState().campaignsLibrary.campaigns;

    if (campaignsToSearchFor && campaignsToSearchFor.length > 0) {
      campaigns = campaigns.filter((campaign) =>
        campaignsToSearchFor.some(
          (campaignToSearchFor) =>
            campaignToSearchFor.id === campaign.id ||
            campaignToSearchFor.name?.toLowerCase() === campaign.name?.toLowerCase(),
        ),
      );
    }

    campaigns = campaigns.slice(0, 10);

    //return very light data, just the id, name, type, status and createTime
    return toolResult(
      tabularDataToCsv(
        campaigns.map((campaign) => ({
          id: campaign.id,
          name: campaign.name,
          type: getMatchingEnumValue(CampaignType, AiCampaignType, campaign.type),
          status: objectStatusName[campaign.status],
          createdAt: campaign.createTime,
        })),
      ),
    );
  }

  return tool({
    displayName: 'Getting campaigns metadata',
    name: CampaignsAgentsToolsNames.GetCampaignsMetadata,
    description: 'Get the current account campaigns metadata',
    execute,
    inputSchema,
  });
}
